import { useEffect, useState } from 'react';

export type Appearance = { mode: 'light' | 'dark' | 'system'; accent: 'blue' | 'violet' | 'green'; density: 'comfortable' | 'compact' };
export const defaultAppearance: Appearance = { mode: 'light', accent: 'blue', density: 'comfortable' };
export function useAppearance(userId?: string) {
  const [state, setState] = useState<{ owner?: string; value: Appearance }>({ value: defaultAppearance });
  const [storageError, setStorageError] = useState('');
  const value = state.owner === userId ? state.value : defaultAppearance;
  useEffect(() => {
    let saved: Appearance = defaultAppearance;
    setStorageError('');
    if (userId) {
      try {
        const raw = JSON.parse(localStorage.getItem(`crm_appearance_${userId}`) || 'null');
        if (raw) saved = {
          mode: ['light', 'dark', 'system'].includes(raw.mode) ? raw.mode : 'light',
          accent: ['blue', 'violet', 'green'].includes(raw.accent) ? raw.accent : 'blue',
          density: ['comfortable', 'compact'].includes(raw.density) ? raw.density : 'comfortable',
        };
      } catch { setStorageError('浏览器偏好读取失败，已使用默认外观。'); }
    }
    setState({ owner: userId, value: saved });
  }, [userId]);
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => {
      document.documentElement.dataset.theme = value.mode === 'system' ? (media.matches ? 'dark' : 'light') : value.mode;
      document.documentElement.dataset.accent = value.accent;
      document.documentElement.dataset.density = value.density;
    };
    apply(); media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [value]);
  function update(next: Appearance) {
    setState({ owner: userId, value: next });
    try {
      if (userId) localStorage.setItem(`crm_appearance_${userId}`, JSON.stringify(next));
      setStorageError('');
    } catch { setStorageError('外观已应用，但浏览器无法保存；刷新后可能恢复默认。'); }
  }
  return { value, update, storageError };
}
